<template>
    <div
        v-if="['game', 'tools'].includes(type)"
        class="tips-box"
    >
        <span
            v-for="(item, index) in data"
            :key="index"
        >
            <span
                v-if="item.show"
                class="tip"
                :class="{[item.type]: true}">
            {{item.name}}
            </span>
        </span>
    </div>
</template>

<script>
export default {
    name: "tips",
    props: {
        type: String,
        data: Array
    }
}
</script>

<style lang="scss" scoped>
.tips-box{
    display: flex;
    flex-direction: row;
    align-items: center;
    /*margin-top: 10px;*/

    .tip{
        padding: 4px 6px;
        background: #2888EE;
        border-radius: 2px;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 18px;
        margin-left: 10px;

        &.on-line{
            background: #46AC79;
        }
        &.double{
            background: #7746AC;
        }
        &.practice{
            background: #ffa859;
        }
    }
}
</style>
